export default "__VITE_ASSET__D04qcUFk__"